export default {
      id: "depth-2-usage",
      viewBox: "0 0 52 15",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#depth-2",
      toString: function () {
        return this.url;
      }
    }